<template>
<div>
<div class="ui container">
  <div class="">
    <GmapMap
      :center="{lat:0, lng:0}"
      :zoom="7"
      map-type-id="terrain"
      style="width: 0px; height: 0px"
    >
    </GmapMap>

      <!-- Modal -->
      <modal name="contact-email-form" id="vehicle-description" style="" :maxWidth="560" :minWidth="260" height="auto" :adaptive="true"  :reset="true" :scrollable="true">
        <div class="ui modal-content">
          <div slot="top-right" style="text-align:right;">
            <button class="ui icon button" @click="closeContactForm()"><i class="times icon"></i></button>
          </div>
          <div slot="top-left" style="text-align:left; padding-left:15px;">
            <h3 v-if="selectedDealer">{{$t('Nachricht an')}} {{selectedDealer.firma}}</h3>
          </div>
          <div style="padding: 15px;">
            <dealer-contact-form :dealer="selectedDealer" :lang="lang" :privacy="config.privacy">  </dealer-contact-form>
          </div>
        </div>
      </modal>

      <!-- Search input field -->
      <div name="mapsSearch" class="ui form">

        <div class="row" style="margin-right:0px;">
          <div style="display: flex;">

            <div class="col-sm-24 searchform" style="width: fit-content; margin:auto; padding-left: 0px;">
              <div style="display: inline;">
              <div class="ui icon input searchmask" style="float:left;margin:6px; z-index:10;">
                <google-autocomplete id="places" v-bind:prevalue="prevalue" classname="['ui','input']"  types="(regions)" v-bind:placeholder="$t('Suche nach PLZ, Ort')" v-on:placechanged="setAddressData" v-bind:googleapikey="config.googleapikey">
                </google-autocomplete>

              </div>

              <div class="full mblackoutline" style="float:left; margin:6px; margin-top:6px">
                <select v-bind:class="['ui','fluid','dropdown',{'disabled': !address},'full']" style="height:47px;" v-model="filter" :disabled="!address"  @change="filterResults()" id="filter">
                <option v-for="tp in mtopics" v-bind:value="tp.id">{{$t(tp.name)}}</option>
                </select>
              </div>
            </div>

              <!--
              <div v-bind:class="['ui', 'red', 'button', {'disabled':dealer.length <= 0},'searchresultbtn']" style="width: 100%; max-width: 200px; font-size: 1.2em;" @click="showList()">
              {{$t('Händler suchen')}} <i class="right arrow icon"></i>
              </div>
            -->
            </div>

          </div>
        </div>

        <br>


        <div class="ui divider"></div>
        <br><br>
      </div>
  </div>

  <div class="row">
      <div class="">
        <div class="col-xs-24 col-sm-12">
            <dealer-list-view v-for="(d,index) in mdealer" :index="index" :dealer="d" :ref="'dv'+index" :vehiclesearchpath="getVehicleSearchPath()" :showDistance="!countryOnly" @openEmailForm="openContactForm($event)"></dealer-list-view>
            <br>
            <div class="col-md-24 col-sm-24 col-xs-24 nopadding" style="width: 100%; text-align:center;">
              <button v-if="mdealer.length > 0 && mdealer.length < 40 && !countryOnly" class="ui primary button red" @click="loadMore()">{{$t('Weitere Händler anzeigen')}}</button>
              <br><br>
            </div>
            <br>
            <br>
        </div>
        <div class="col-xs-24 col-sm-12">
          <GmapMap v-if="mdealer && mdealer.length>0"
    :center=center
    :zoom="getZoom()"
    :draggable="false"
    :options="{mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,}"
    style="width: 100%; height: 600px"
  >
  <gmap-custom-marker
  v-for="(m, index) in mdealer"
  :marker="{lat: parseFloat(m.lat), lng: parseFloat(m.lng)}"
  :clickable="true"
  >
    <gmap-dealer-marker :index="index" :title="m.firma" :dealer="m" @mapMarkerClicked="onmMarkerClicked($event)"></gmap-dealer-marker>
  </gmap-custom-marker>

  </GmapMap>

  <div class="col-md-24 col-sm-24 col-xs-24 nopadding" style="width: 100%; text-align:center; margin-top:12px;">
    <button v-if="mdealer.length > 0 && mdealer.length < 40 && !countryOnly" class="ui primary button red" @click="loadMore()">{{$t('Weitere Händler anzeigen')}}</button>
    <br><br>
  </div>
        </div>
      </div>
  </div>
  <div class="row" v-if="mdealer.length > 0" >
    <br><br>
    <div class="col-xs-24 col-sm-12">
        <h5><sup>*</sup><i class="icon red"><font-awesome-icon icon="certificate" /></i>{{$t('Top-Händler - Von rewaco ausgezeichneter Kundenservice.')}}</h5>
        <br><br>
    </div>
  </div>

  <div class="row" v-if="mdealer.length == 0 && address != null && !searching" >
    <br><br>
    <div class="col-xs-24 col-sm-24" style="text-align:center;">
        <h5>{{$t('Keine Händler gefunden.')}}</h5>
        <br><br>
    </div>
  </div>

</div>



</div>
</template>

<script>

const mapMarker = require('../assets/mapmarker.svg');

import Config from '../Config';
import {
  mapState,
  mapActions
} from 'vuex'
import {
  formatDateOnly
} from '../utils/DateFormatter.js'
import GoogleAutocomplete from './sections/GoogleAutoComplete'
import DealerListView from './sections/DealerListView'
import GmapDealerMarker from './sections/GmapDealerMarker'
//import DealerContactForm from './sections/DealerContactForm'
import VueScrollTo from 'vue-scrollto';
import {
  i18n
}
from '../plugins/i18n.js';
import GmapCustomMarker from 'vue2-gmap-custom-marker';

export default {
  name: 'Search',
  props: {},
  data: function() {
    return {
      searching: false,
      mdistance: 0,
      mcountry: "DE",
      mdealer: [],
      prevalue: '',
      filter: 0,
      lang: 'de',
      limit: 5,
      mtopics: [],
      countryOnly: false,
      country: 'de',
      config: Config,
      center: {},
      selectedDealer: null
    }
  },
  components: {
    GoogleAutocomplete,
    DealerListView,
    GmapDealerMarker,
    'dealer-contact-form': () => import('./sections/DealerContactForm'),
    'gmap-custom-marker': GmapCustomMarker
  },
  computed: {

    dealer() {
      return this.$store.state.summery.dealer;
    },
    address() {
      return this.$store.state.summery.address;
    },
    topic() {
      return this.$store.state.summery.topic;
    },
    topics() {
      return this.$store.state.summery.topics;
    }
  },
  watch: {

    address(newValue, oldValue) {
      let ww = $( window ).width();
      if(ww < 730){
        setTimeout(function () {
          VueScrollTo.scrollTo('#dealerview-0',1000,{offset:-114});
          this.$refs[`dv0`][0].activate();
        }, 200);
      }
    },
    dealer(newValue, oldValue){
      let tt = [];
      if(this.countryOnly){
        let mm = this.country;
        if(newValue.length > 0 ){
          for(let index in newValue){
            if(newValue[index].staat.indexOf(mm) >= 0) {
              tt.push(newValue[index]);
            }
          }

          tt.sort((a, b) => (a['firma'] > b['firma']) ? 1 : -1);
          //if (rev == 'desc') state.vehicles.reverse();
        }

        this.mdealer = tt;

      }else{
        this.mdealer = newValue;
      }
    }

  },
  created() {

    this.lang = i18n.locale;
    this.filter = this.topic;

    this.mtopics = this.topics.map(t => {return t});

    if( this.topics[0].name == "Allgemein" ) {
    this.mtopics[0] ={
      id: 0,
      name: 'Alle'
    }
  }

  },
  methods: {
    setAddressData: function(addressData, placeResultData, id) {
      this.limit = 5;

      if(addressData.administrative_area_level_1 == undefined){
          //addressData.latitude = 0;
          //addressData.longitude = 0;
          this.countryOnly = true;
          this.country = addressData.country.toUpperCase();
          this.limit = 50;

          this.$store.commit('summery/address', addressData);
      } else {
          this.countryOnly = false;
          this.$store.commit('summery/address', addressData);
      }

      this.getAvailableDealer(this.address.latitude,this.address.longitude, this.limit, this.filter);
    },
    setMapCenter: function(){

    },
    getVehicleSearchPath: function(){

      return this.config['available_trikes_path_' + this.lang];
    },
    closeContactForm: function(){

      this.$modal.hide('contact-email-form')
      this.selectedDealer = null;

    },
    getZoom: function(){

      let maxDistance = this.dealer[this.dealer.length-1].distance;
      let zoom = 9;

      zoom =  Math.round(14-Math.log(maxDistance)/Math.LN2)

      return zoom;
    },
    openContactForm: function(e){
      this.selectedDealer = e;
      this.$modal.show('contact-email-form')
    },
    loadMore: function(){
      this.limit += 10;
      this.filterResults(this.filter);
    },
    onmMarkerClicked: function(index){

      for(let i in this.dealer){
        //  this.$refs[`dv`+i][0].deactivate()
      }

      VueScrollTo.scrollTo('#dealerview-'+index,1000,{offset:-114});
      this.$refs[`dv`+index][0].activate();

      //this.center = {lat: parseFloat(this.dealer[index].lat), lng:parseFloat(this.dealer[index].lng)}
    },
    filterResults: function(id){
      this.$store.commit('summery/filter', this.filter);
      this.$store.commit('summery/topic',this.filter);
      this.getAvailableDealer(this.address.latitude,this.address.longitude, this.limit, this.filter);
    },
    getAvailableDealer: function(lat,lng,limit, filter){
      this.searching = true;

      this.$store.dispatch('summery/dealerByLocation', {
        lat: lat,
        lng: lng,
        limit: limit,
        filter: filter
      }).then((count) => {
        this.searching = false;
        this.center = {lat: parseFloat(this.dealer[0].lat), lng:parseFloat(this.dealer[0].lng)}
      })
    },
    clearAdressInput: function(){
      //this.prevalue = '';
    }
  }

}
</script>

<style scoped>


.step{
  background-color: rgb(238, 238, 238);
  display: inline;
  padding:10px;
  padding-bottom: 14px;
}
.ui.input {
    font-size: 1.2em;
}

.searchmask{
  min-width: 500px;
}

.mcontainer {
  display: inline;;
  position: relative;
  padding-left: 28px;
  margin-bottom: 12px;
  cursor: pointer;
  float: none;
  font-size: 1em;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-right: 10px;
}

.ui.fluid.dropdown {
    display: block;
  width: auto;
    min-width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: -4;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: rgb(248, 248, 248);
}

/* On mouse-over, add a grey background color */
.mcontainer:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.mcontainer input:checked ~ .checkmark {
  background-color: #c51a1b;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.mcontainer input:checked ~ .checkmark:after {
  display: block;
}

/* On mouse-over, add a grey background color */
.mcontainer:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.mcontainer input:checked ~ .checkmark {
  background-color: #c51a1b;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.mcontainer input:checked ~ .checkmark:after {
  display: block;
}


/* Style the checkmark/indicator */
.mcontainer .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

input[type="checkbox"]{
  display: none;
}

input[type="text"]{
  height: 44px;
}

select.ui.dropdown {
    height: 44px;
}
.searchform{
  text-align: center;
  padding-right: 0px;
}
.searchresultbtn{
  margin-left: 20px;
  margin-top: 10px;
}

.full{
  width: auto;
}

@media only screen and (max-width: 772px) {

  .full{
    width: 100%!important;
  }
  .searchmask{
    min-width: 100%;
  }
}


.step{
  margin-bottom: 14px;
}

.textshadow {
  text-shadow: 2px 2px rgba(0,0,0,0.3);
}
.textshadowl {
  text-shadow: 2px 2px rgba(0,0,0,0.1);
}

</style>
